export type CompanionFreshnessState =
  | "updated-today"
  | "updated-yesterday"
  | "stale"
  | "missing";

export type CompanionFreshness = {
  state: CompanionFreshnessState;
  label: string;
  ageHours: number | null;
};

const TODAY_HOURS = 24;
const YESTERDAY_HOURS = 48;

export function buildCompanionFreshness(
  updatedAt: string | null,
  now: Date,
): CompanionFreshness {
  if (!updatedAt) return missingFreshness();

  const updatedTime = Date.parse(updatedAt);
  if (!Number.isFinite(updatedTime)) return missingFreshness();

  const rawAgeHours = (now.getTime() - updatedTime) / (60 * 60 * 1000);
  const ageHours = Math.max(0, round2(rawAgeHours));

  if (rawAgeHours <= TODAY_HOURS) {
    return { state: "updated-today", label: "Updated today", ageHours };
  }
  if (rawAgeHours <= YESTERDAY_HOURS) {
    return { state: "updated-yesterday", label: "Updated yesterday", ageHours };
  }
  return { state: "stale", label: "Stale", ageHours };
}

function missingFreshness(): CompanionFreshness {
  return {
    state: "missing",
    label: "No fresh score",
    ageHours: null,
  };
}

function round2(value: number): number {
  return Math.round(value * 100) / 100;
}
